import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';
import { NotificationData, NotificationType } from './notification-data.model';
import { NotificationComponent } from './notification/notification.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  show(message: string, type: NotificationType = NotificationType.info, duration: number = 5000): MatSnackBarRef<NotificationComponent> {
    const config: MatSnackBarConfig<NotificationData> = {
      duration: duration,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: [`notification-${type}`],
      data: {
        message,
        type
      }
    };

    return this.snackBar.openFromComponent(NotificationComponent, config);
  }

  showInfo(message: string, duration?: number): MatSnackBarRef<NotificationComponent> {
    return this.show(message, NotificationType.info, duration);
  }

  showWarning(message: string, duration?: number): MatSnackBarRef<NotificationComponent> {
    return this.show(message, NotificationType.warning, duration);
  }

  showSuccess(message: string, duration?: number): MatSnackBarRef<NotificationComponent> {
    return this.show(message, NotificationType.success, duration);
  }

  showError(message: string, duration?: number): MatSnackBarRef<NotificationComponent> {
    return this.show(message, NotificationType.error, duration);
  }

  dismiss(): void {
    this.snackBar.dismiss();
  }
}
